import React from 'react'
import { WidthProvider, Responsive } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import * as styles from './style.module.css';

const ResponsiveGridLayout = WidthProvider(Responsive);

const ReactGrid = ({ config = {}, children }) => {

  const defaultConfig = {
    rowHeight: 20,
    margin: [15, 20],
    containerPadding: [5, 10],
    isDraggable: false,
    isResizable: false,
  }

  const finalConfig = { ...defaultConfig, ...config };

  return (
    <div className={styles.reactGridWrapper}>
      <ResponsiveGridLayout
        {...finalConfig}
        className={`${styles.reactGridLayout} ${config?.className}`}
      >
        {children}
      </ResponsiveGridLayout>
    </div>
  )
}

export default ReactGrid
